import { Box, Stack, Typography } from '@mui/material';

import { DraggableListItemInnerComponentProps } from '@/components/lists/DragAndDropList/DraggableListItem.types';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { DOCUMENT_TYPE_DISPLAY_NAMES } from '@/modules/documents/documents.constants';
import { DocumentType } from '@/types/schema';
import { truncateToLength } from '@/utils/stringUtils';

interface AmendmentDocument {
  id: string;
  name: string;
  type: DocumentType;
  isCurrentDocument: boolean;
}

const DOCUMENT_NAME_TRUNCATE_LENGTH = 50;

function getDocumentTypeDisplay(docType: DocumentType) {
  return DOCUMENT_TYPE_DISPLAY_NAMES[docType] ?? 'Other';
}

export function AmendmentItem({
  item,
  Draghandle,
}: DraggableListItemInnerComponentProps<AmendmentDocument>) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 2,
      }}
    >
      {Draghandle}

      <Stack sx={{ flex: 1 }}>
        <Typography
          variant="body-xs"
          sx={{ fontWeight: 600 }}
          title={
            item.name.length > DOCUMENT_NAME_TRUNCATE_LENGTH
              ? item.name
              : undefined
          }
        >
          {truncateToLength(item.name, DOCUMENT_NAME_TRUNCATE_LENGTH)}
        </Typography>
        <Typography variant="body-xs" color="text.secondary">
          {getDocumentTypeDisplay(item.type)}
        </Typography>
        {item.isCurrentDocument && (
          <Badge
            sx={{ display: 'inline-block' }}
            wrapperSx={{ display: 'inline-block' }}
            variant={BadgeVariants.Success}
            display="This document"
          />
        )}
      </Stack>
    </Box>
  );
}
